<template>
  <div >
      <el-dialog
      v-model="dialogVisible"
      title="微信扫码咨询客服"
      width="900"
      :before-close="handleClose"
      body-class="dialogbox"
    >
      <div class="wcimg">
        <img src="../assets/wxcode.jpg" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue';
let dialogVisible = ref(false)
const handleClose =()=>{
    dialogVisible.value = false
}
defineExpose({
  dialogVisible
});

</script>
<style scoped lang='scss'>
  ::v-deep .dialogbox{
    display: flex;
    justify-content: center;
  }
  .wcimg{
    width: 400px;
    height: 400px;
   img{
    width: 100%;
    height: 100%;
   }
  }
</style>